import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { FREE_SERIES, NEW_SERIES, TOP_SERIES } from "../../utils/constants";
import Card from "../card/card";
import styles from "./cards.module.scss";

export default function Cards({
  type,
  pageView,
  cardsData = [],
  callbackScroll,
  section_type,
}) {
  const cardsRef = useRef();
  const scrollRef = useRef();
  const [scrollAmount, setScrollAmount] = useState(0);
  const [isFirstVisible, setIsFirstVisible] = useState(false);
  const [isLastVisible, setIsLastVisible] = useState(false);

  const firstCard = useRef();
  const firstCardElementRef = useCallback(
    (node) => {
      if (firstCard.current) firstCard.current.disconnect();
      firstCard.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setIsFirstVisible(true);
        } else {
          setIsFirstVisible(false);
        }
      });
      if (node) firstCard.current.observe(node);
    },
    [scrollAmount]
  );

  const lastCard = useRef();
  const lastCardElementRef = useCallback(
    (node) => {
      if (lastCard.current) lastCard.current.disconnect();
      lastCard.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setIsLastVisible(true);
        } else {
          setIsLastVisible(false);
        }
      });
      if (node) lastCard.current.observe(node);
    },
    [scrollAmount]
  );

  useEffect(() => {
    if (type == NEW_SERIES) callbackScroll(scrollAmount, scrollRef);
  }, [scrollAmount]);

  useEffect(() => {
    if (type !== FREE_SERIES) {
      if (isFirstVisible) {
        scrollLeft();
      } else if (isLastVisible) {
        scrollRight();
      }
    }
  }, [isFirstVisible, isLastVisible]);

  const scrollLeft = () => {
    const divWidth =
      +window
        .getComputedStyle(cardsRef.current)
        .getPropertyValue("width")
        .split("px")[0] * 10;
    const scrollTo = isFirstVisible
      ? scrollAmount
      : isLastVisible
      ? scrollAmount - divWidth
      : scrollAmount - divWidth / 2;
    if (scrollAmount >= 0) {
      cardsRef.current.scrollTo({
        top: 0,
        left: scrollTo,
        behavior: "smooth",
      });
      setScrollAmount(scrollTo);
    }
    console.log("scroll left", divWidth, isFirstVisible, scrollTo);
  };

  const scrollRight = () => {
    let divWidth =
      +window
        .getComputedStyle(cardsRef.current)
        .getPropertyValue("width")
        .split("px")[0] * 100;
    if (isLastVisible) divWidth = divWidth * cardsData.length;
    const scrollTo = scrollAmount + 300;
    cardsRef.current.scrollTo({
      top: 0,
      left: scrollTo,
      behavior: "smooth",
    });
    setScrollAmount(scrollTo);
    console.log("scroll right", divWidth, isFirstVisible, scrollTo);
  };

  const scroll = (e) => {
    const scrollTo = e.target.scrollLeft;
    // cardsRef.current.scrollTo({
    //     top: 0,
    //     left: 300,
    //     behavior: 'smooth'
    // });
    setScrollAmount(scrollTo);
  };

  return (
    <div
      ref={scrollRef}
      className={`${styles.horizontalScroll} ${
        type === NEW_SERIES
          ? pageView !== "category" && styles.newSeries_wrapper
          : ""
      }`}
    >
      {!isFirstVisible && (
        <div className={styles.leftArrowButton}>
          <button onClick={scrollLeft}>
            <FontAwesomeIcon icon={faAngleLeft} size="2x" />
          </button>
        </div>
      )}
      <div
        className={`${styles.cards} ${
          type == NEW_SERIES && pageView !== "category" && styles.newSeries
        } ${type == TOP_SERIES && styles.top_free_series_horizontal} ${
          type == "top_10_series" && styles.top_free_series_horizontal
        }`}
        ref={cardsRef}
        onScroll={scroll}
      >
        {type === NEW_SERIES && <div className={styles.blankcard}></div>}
        <div style={{ width: "10px" }}></div>
        {cardsData?.map((cardData, index) => {
          const cardRef =
            index === 0
              ? firstCardElementRef
              : index === cardsData.length - 1
              ? lastCardElementRef
              : null;
          return (
            <Card
              type={type}
              key={`card-${index + 1}`}
              cardData={
                cardData?.type === "series" ? cardData?.series : cardData
              }
              index={index}
              cardRef={cardRef}
              section_type={section_type}
            />
          );
        })}
      </div>

      {!isLastVisible && (
        <div className={styles.rightArrowButton}>
          <button onClick={scrollRight}>
            <FontAwesomeIcon icon={faAngleRight} size="2x" />
          </button>
        </div>
      )}
    </div>
  );
}
